<p-scrollPanel [style]="{ height: height() }">
  <ng-content></ng-content>
</p-scrollPanel>
